const constants = require('../constants');

/* Variabili globali */
window.isMobile = window.isMobile || false;
window.isTablet = window.isTablet || false;
window.isTabletPortrait = window.isTabletPortrait || false;
window.isTabletLandscape = window.isTabletLandscape || false;
window.isDesktop = window.isDesktop || false;

/* Funzioni Globali */
const setHeaderHeight = () => {
    if ($('.cc-header__main').length > 0) {
        const headerHeight = $(document).find('.cc-header__main').outerHeight(true);
        document.documentElement.style.setProperty('--headerHeight', headerHeight / 10 + 'rem');
    }
};

const setFooterHeight = () => {
    if ($('.cc-footer').length > 0) {
        const footerHeight = $(document).find('.cc-footer').outerHeight(true);
        document.documentElement.style.setProperty('--footerHeight', footerHeight / 10 + 'rem');
    }
};

const setFullHeight = () => {
    const windowHeight = $(window).innerHeight();
    document.documentElement.style.setProperty('--windowHeight', windowHeight / 10 + 'rem');
};

/**
 * Enforce no focus on elements with class js-no-focus
 * This is used to prevent focus on elements that should not be focused
 * e.g. elements that are not interactive or should not receive keyboard focus
 */
const enforceNoFocus = ($context) => {
    $context.find('.js-no-focus').each(function () {
        this.setAttribute('tabindex', '-1');
    });
};

/**
 * Initialize sliders with Slick
 */
const initializeSliders = () => {
    $('.js-slider').each(function () {
        const $slider = $(this);

        if ($slider.hasClass('slick-initialized')) {
            setTimeout(() => enforceNoFocus($slider), 0);
            return;
        }

        let settings = $slider.data('slick');

        if (typeof settings === 'string') {
            try {
                settings = JSON.parse(settings);
            } catch (e) {
                console.warn('Parsing error of data-slick:', e);
                settings = {};
            }
        }

        let customPrev = null;
        let customNext = null;

        if (typeof settings.customPrevArrow === 'string') {
            try {
                const $candidate = $(settings.customPrevArrow);
                if ($candidate.length) {
                    customPrev = $candidate.get(0);
                }
            } catch (err) {
                console.warn(`Invalid customPrevArrow selector: "${settings.customPrevArrow}"`, err);
            }
        }

        if (typeof settings.customNextArrow === 'string') {
            try {
                const $candidate = $(settings.customNextArrow);
                if ($candidate.length) {
                    customNext = $candidate.get(0);
                }
            } catch (err) {
                console.warn(`Invalid customNextArrow selector: "${settings.customNextArrow}"`, err);
            }
        }

        settings.prevArrow = customPrev || '<button class="slick-prev slick-arrow" aria-label="Mostra la slide precedente" type="button">Mostra la slide precedente</button>';
        settings.nextArrow = customNext || '<button class="slick-next slick-arrow" aria-label="Mostra la slide successiva" type="button">Mostra la slide successiva</button>';

        $slider.slick(settings);
        $slider.slick('getSlick').$dots && $slider.slick('getSlick').$dots.find('button').off('focus');
        $slider.find('[role="tabpanel"]').removeAttr('role');

        // Update arrow visibility right after init
        const updateCustomArrowVisibility = (slick) => {
            const total = slick.slideCount;
            const visible = slick.options.slidesToShow;
            const infinite = slick.options.infinite;
            const shouldHide = !infinite && total <= visible;

            let $prev = $();
            let $next = $();

            if (typeof settings.customPrevArrow === 'string') {
                try {
                    $prev = $(settings.customPrevArrow);
                } catch (err) {
                    console.warn(`Invalid customPrevArrow in visibility check: "${settings.customPrevArrow}"`, err);
                }
            }

            if (typeof settings.customNextArrow === 'string') {
                try {
                    $next = $(settings.customNextArrow);
                } catch (err) {
                    console.warn(`Invalid customNextArrow in visibility check: "${settings.customNextArrow}"`, err);
                }
            }

            if ($prev.length) $prev.toggleClass('slick-hidden', shouldHide);
            if ($next.length) $next.toggleClass('slick-hidden', shouldHide);
        };

        updateCustomArrowVisibility($slider.slick('getSlick'));

        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            const $currentSlide = $(slick.$slides.get(currentSlide));
            $currentSlide.find('*').blur();
        });

        $slider.on('init afterChange setPosition', function (e, slick) {
            setTimeout(() => {
                const $prev = $(slick.$prevArrow);
                const $next = $(slick.$nextArrow);

                [$prev, $next].forEach(($el) => {
                    const isHiddenBySlideCount = slick.slideCount <= slick.options.slidesToShow;
                    const isDisabled = $el.hasClass('slick-disabled');

                    $el.toggleClass('slick-hidden', isHiddenBySlideCount);
                    $el.attr('aria-hidden', false);
                    $el.attr('aria-disabled', isDisabled || isHiddenBySlideCount ? 'true' : 'false');
                    $el.attr('tabindex', isDisabled || isHiddenBySlideCount ? '-1' : '0');
                });

                const $dots = $slider.find('.slick-dots');
                $dots.removeAttr('role');
                $dots.find('li').removeAttr('role');
                $dots.find('button')
                    .removeAttr('role aria-selected aria-controls aria-label')
                    .attr('tabindex', '-1')
                    .attr('aria-hidden', 'true');

                enforceNoFocus($slider);

                $slider.find('.slick-slide[aria-hidden="true"] svg, .slick-slide[aria-hidden="true"] use')
                    .attr('focusable', 'false')
                    .attr('tabindex', '-1');

            }, 0);
        });
    });
};

const responsiveResize = () => {
    getWindowSizes();
    setHeaderHeight();
    setFooterHeight();
    setFullHeight();
    getWindowBrowser();

    if ($('.js-slider').length > 0) {
        initializeSliders();
    }
};

/**
 * Get the window size and set the global variables
 */
const getWindowSizes = () => {
    if (window.matchMedia('(max-width: 767.98px)').matches) {
        $('body')
            .addClass('cc-mobile')
            .removeClass('cc-tablet')
            .removeClass('cc-desktop');
        window.isMobile = true;
        window.isTablet = false;
        window.isDesktop = false;
    } else if (window.matchMedia('(max-width: 1199.98px)').matches) {
        $('body')
            .removeClass('cc-mobile')
            .addClass('cc-tablet')
            .removeClass('cc-desktop');
        window.isMobile = false;
        window.isTablet = true;
        window.isDesktop = false;
    } else {
        $('body')
            .removeClass('cc-mobile')
            .removeClass('cc-tablet')
            .addClass('cc-desktop');
        window.isMobile = false;
        window.isTablet = false;
        window.isDesktop = true;
    }
}

/**
 * Get the browser and add a class to the body
 */
getWindowBrowser = () => {
    const isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    const isFirefox = typeof InstallTrigger !== 'undefined';
    const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    const isEdge = !isIE && !!window.StyleMedia;
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    const isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
    const isBlink = (isChrome || isOpera) && !!window.CSS;

    if (isOpera) {
        $('body').addClass('cc-opera');
    } else if (isFirefox) {
        $('body').addClass('cc-firefox');
    } else if (isSafari) {
        $('body').addClass('cc-safari');
    } else if (isIE) {
        $('body').addClass('cc-ie');
    } else if (isEdge) {
        $('body').addClass('cc-edge');
    } else if (isEdgeChromium) {
        $('body').addClass('cc-edgeChromium');
    } else if (isChrome) {
        $('body').addClass('cc-chrome');
    } else if (isBlink) {
        $('body').addClass('cc-blink');
    } else {
        $('body').addClass('cc-unknown-browser');
    }
}

window.AOS = require('aos');

$(() => {
    responsiveResize();
    patchMobileOnlyAccordionButtons();
    $.fn.selectpicker.Constructor.BootstrapVersion = '4';
    $.fn.selectpicker.Constructor.DEFAULTS.title = null;

    // Select
    if ($('.js-form-select.selectpicker').length > 0) {
        $('.js-form-select.selectpicker').each(function () {
            $(this).selectpicker('refresh');
            $(this).find('option[value=""]').hide().closest('select').selectpicker('refresh');
            const label = $(this).closest('.cc-form__wrap').find('.cc-form__label').html();
            const selectId = $(this).attr('id');
            const htmlString = '<label class="cc-form__label cc-visibility-hidden" for="button-' + selectId + '">' + label + '</label>';

            $(this).closest('.js-form-select').find('.dropdown-toggle').attr('aria-label', label);
            $(this).closest('.js-form-select').find('.dropdown-toggle').attr('aria-controls', 'button-' + selectId);
            $(this).closest('.js-form-select').find('.dropdown-menu > .inner').attr('id', 'button-' + selectId);
            $(this).closest('.js-form-select').find('.dropdown-menu').prepend(htmlString);
            $(this).closest('.js-form-select').find('.dropdown-toggle').removeAttr('title');
        });
    }

    // Prevent click on swipe
    $('.js-slider.slick-initialized').each(function () {
        let isSliding = false;
        $(this).on('beforeChange', function() {
            isSliding = true;
        });
        $(this).on('afterChange', function() {
            isSliding = false;
        });
        $(this).find('a').off('click').on('click', function(e) {
            if (isSliding) {
                e.stopImmediatePropagation();
                e.stopPropagation();
                e.preventDefault();
                return;
            }
        });
    });

    // Tooltip
    $('[data-toggle="tooltip"]').tooltip();

    /* ACCESSIBILITY PATCHS */
    
    // Bootstrap Select Patch START
    function patchAccessibleSelect($select, index) {
        const $wrapper = $select.closest('.bootstrap-select');
        const $btn = $wrapper.find('button.dropdown-toggle');
        const $menu = $wrapper.find('.dropdown-menu.inner');

        if ($wrapper.attr('data-accessibility-patched') === 'true') return;

        const menuId = `accessible-select-menu-${index}`;
        const labelId = `accessible-select-label-${index}`;
        const labelText = $(`label[for="${$select.attr('id')}"]`).text().trim();

        $wrapper.find('.dropdown-menu').removeAttr('role');

        $select.removeAttr('aria-label');
        $select.removeAttr('title');
        $select.removeAttr('aria-labelledby');
        $btn.removeAttr('title');

        $btn.attr({
            'role': 'combobox',
            'aria-haspopup': 'listbox',
            'aria-expanded': 'false',
            'aria-controls': menuId,
            'aria-label': labelText
        });

        $menu.attr({
            'role': 'listbox',
            'id': menuId
        });

        $menu.find('li').each(function () {
            const $link = $(this).find('a');
            $link.attr('role', 'option');
            $link.attr('aria-selected', $(this).hasClass('selected') ? 'true' : 'false');
        });

        $btn.on('click', function () {
            const expanded = $(this).attr('aria-expanded') === 'true';
            $(this).attr('aria-expanded', String(!expanded));
        });

        $menu.find('li a').on('keydown', function (e) {
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                $(this).parent().next().find('a').focus();
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                $(this).parent().prev().find('a').focus();
            } else if (e.key === 'Escape') {
                $btn.focus().attr('aria-expanded', 'false');
            }
        });

        $menu.on('hide.bs.dropdown', function () {
            $btn.attr('aria-expanded', 'false').focus();
        });

        $menu.find('li a').on('click', function () {
            $menu.find('li a').attr('aria-selected', 'false');
            $(this).attr('aria-selected', 'true');

            const selectedText = $(this).text().trim();
            const label = labelText || 'Option';
            $('#selectLiveRegion').text(`${label} selected: ${selectedText}`);

            $btn.focus();
        });

        $wrapper.attr('data-accessibility-patched', 'true');
        setTimeout(() => {
            $btn.removeAttr('title');
            const observer = new MutationObserver(() => {
                $btn.removeAttr('title');
            });
            observer.observe($btn[0], { attributes: true, attributeFilter: ['title'] });
        }, 50);
    }

    function patchAllAccessibleSelects() {
        $('select.selectpicker').each(function (i) {
            const $select = $(this);
            const $wrapper = $select.closest('.bootstrap-select');
            if ($wrapper.length && $wrapper.find('.dropdown-toggle').length) {
                patchAccessibleSelect($select, i);
            }
        });
    }

    // Bootstrap Select Patch Call START
    if (!$('#selectLiveRegion').length) {
        $('body').append(
            '<div id="selectLiveRegion" class="sr-only" role="status" aria-live="polite" aria-atomic="true"></div>'
        );
    }
    // Primo patch iniziale
    patchAllAccessibleSelects();
    // Patcha ogni volta che cambia il DOM (es. modali, AJAX, overlay)
    const observer = new MutationObserver(function () {
        patchAllAccessibleSelects();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    $('select.cc-select.selectpicker').each(function () {
        $(this).attr('aria-hidden', true);
    });
    // Bootstrap Select Patch Call END
    
    // Bootstrap Select Patch END

    /* FOCUS PATCHS */
    document.body.classList.add('using-mouse');
    window.addEventListener('keydown', function(e) {
    if (e.key === 'Tab') {
        document.body.classList.remove('using-mouse');
    }
    });

    window.addEventListener('mousedown', function() {
        document.body.classList.add('using-mouse');
    });

    /**
     * Patch WCAG 2.2 AA for Bootstrap 4.6 modals
     * - Saves and restores last focused element
     * - Ensures focus trap inside modal
    */
    function patchModalAccessibility() {
        let lastFocusedBeforeModal = null;

        // Save focus BEFORE Bootstrap moves it
        $(document).on('show.bs.modal', '.modal', function () {
            if (
                !$('body').hasClass('using-mouse') &&
                !$(document.activeElement).closest('.modal, .cc-overlay, .js-overlay').length
            ) {
                lastFocusedBeforeModal = document.activeElement;
            }
        });

        // Hide main content and focus modal
        $(document).on('shown.bs.modal', '.modal', function () {
            const $modal = $(this);
            $('.cc-header, #maincontent, .cc-footer').attr('aria-hidden', 'true');

            const $sliders = $(this).find('.js-slider:not(.slick-initialized)');
            if ($sliders.length > 0) {
                $sliders.removeClass('slick-initialized');
                initializeSliders();
            }

            if (!$('body').hasClass('using-mouse')) {
                $modal.attr('tabindex', '-1').focus();
            }
        });

        // Restore focus and clean aria-hidden
        $(document).on('hidden.bs.modal', '.modal', function () {
            if (
                lastFocusedBeforeModal &&
                typeof lastFocusedBeforeModal.focus === 'function' &&
                document.body.contains(lastFocusedBeforeModal)
            ) {
                lastFocusedBeforeModal.focus();
            }
            lastFocusedBeforeModal = null;

            if ($('.modal.show').length === 0) {
                $('.cc-header, #maincontent, .cc-footer').removeAttr('aria-hidden');
            }
        });

        // Trap focus inside modal
        $(document).on('keydown', '.modal', function (e) {
            if (e.key !== 'Tab') return;

            const $modal = $(this);
            const $focusable = $modal.find(
                'a[href], area[href], input:not([disabled]):not([type=hidden]), ' +
                'select:not([disabled]), textarea:not([disabled]), ' +
                'button:not([disabled]), iframe, object, embed, ' +
                '[tabindex]:not([tabindex="-1"]):not(.modal), [contenteditable=true]'
            ).filter(':visible');

            if ($focusable.length === 0) return;

            const first = $focusable[0];
            const last = $focusable[$focusable.length - 1];

            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }

            const $iframe = $modal.find('iframe').filter(':visible');
            if ($iframe.length > 0) {
                $iframe.each(function () {
                    try {
                        const iframeDoc = this.contentDocument || this.contentWindow.document;
                        $(iframeDoc).off('keydown.trapfocus').on('keydown.trapfocus', function (event) {
                            if (event.key === 'Tab') {
                                event.preventDefault();
                                if (e.shiftKey) {
                                    last.focus();
                                } else {
                                    first.focus();
                                }
                            }
                        });
                    } catch (err) {
                        console.warn('Cannot trap focus in cross-domain iframe');
                    }
                });
            }
        });

        // Optional fallback: observe if modals are removed directly (non-standard)
        const modalObserver = new MutationObserver(() => {
            if ($('.modal.show').length === 0) {
                $('.cc-header, #maincontent, .cc-footer').removeAttr('aria-hidden');
            }
        });

        modalObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    function patchIframeFocusTrap() {
        $(document).on('focusin', '.js-trap-iframe-out', function () {
            const $modal = $('.modal.show');

            if ($modal.length > 0) {
                const $focusable = $modal.find(
                    'a[href], area[href], input:not([disabled]):not([type=hidden]), ' +
                    'select:not([disabled]), textarea:not([disabled]), ' +
                    'button:not([disabled]), iframe, object, embed, ' +
                    '[tabindex]:not([tabindex="-1"]):not(.modal), [contenteditable=true]'
                ).filter(':visible');

                if ($focusable.length > 0) {
                    $focusable.first().focus();
                }
            }
        });
    }

    patchModalAccessibility();
    patchIframeFocusTrap();
    /* FOCUS PATCHS END */

    /* Mobile Only Accordion Buttons */
    function patchMobileOnlyAccordionButtons() {
        const isMobile = window.matchMedia('(max-width: 1023.98px)').matches;

        $('.js-accordion-button-mobile-only').each(function () {
            const $btn = $(this);

            if (isMobile) {
                $btn.attr('type', 'button');
                $btn.attr('aria-expanded', $btn.attr('aria-expanded') || 'false');
                $btn.attr('aria-controls', $btn.data('target')?.replace('#', '') || '');
                $btn.attr('role', 'button');
                $btn.prop('disabled', false);
            } else {
                $btn.removeAttr('type aria-expanded aria-controls role');
                $btn.prop('disabled', true);
            }
        });
    }


    /* END ACCESSIBILITY PATCHS */


    // Data AOS
    AOS.init({
        // Global settings:
        disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
        startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
        initClassName: 'aos-init', // class applied after initialization
        animatedClassName: 'aos-animate', // class applied on animation
        useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
        disableMutationObserver: false, // disables automatic mutations' detections (advanced)
        debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
        throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

        // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
        offset: 300, // offset (in px) from the original trigger point
        delay: 0, // values from 0 to 3000, with step 50ms
        duration: 1000, // values from 0 to 3000, with step 50ms
        easing: 'ease', // default easing for AOS animations
        once: true, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: 'top-bottom' // defines which position of the element regarding to window should trigger the animation
    });
    // refresh AOS after images with a lazy loading are loaded
    $('img.cc-imgLazy').on('load', () => AOS.refresh());

    $('body').on('reinitSlick', () => {
        if ($('.js-slider').length > 0) {
            initializeSliders();
        }
    });

    $(window).on('resize', () => {
        responsiveResize();
        patchMobileOnlyAccordionButtons();
    });
});

/**
 * Display an alert message
 * @param {String} $text - Text to display
 * @param {String} $class - Class to add to the alert
 */
const alertMessage = ($text, $class, hasCartLink = false) => {
    const successTimeout = 4000;
    const linkToCartTimeout = 6000;
    const dangerTimeout = 6000;
    let timeout = successTimeout;

    const $alert = $('.js-alert');
    const $alertMessage = $('.js-alert-message');

    let lastFocusedElement = null;

    if ($text && $text !== '') {
        // Save last focused element (keyboard users only)
        if (!$('body').hasClass('using-mouse') && !$(document.activeElement).closest('.js-overlay, .modal, .cc-overlay').length) {
            lastFocusedElement = document.activeElement;
        }

        // Immediately update the message BEFORE showing the alert
        let messageHTML = $text;
        if (hasCartLink && $class !== 'cc-alert--danger') {
            timeout = linkToCartTimeout
            const cartUrl = $alertMessage.data('cart-link') || '';
            const gotoCartLabel = $alertMessage.data('cart-text') || '';
            messageHTML += ` <a class="cc-alert__link-cart" href="${cartUrl}" aria-hidden="true" tabindex="-1">${gotoCartLabel}</a>`;
        }

        $alertMessage.empty().html(messageHTML);

        // Show the alert and make it accessible
        $alert
            .removeClass('cc-active') // reset state
            .removeClass('cc-alert--danger cc-alert--success cc-alert--info') // remove old styles
            .addClass($class)
            .addClass('cc-active')
            .attr('aria-hidden', 'false')
            .attr('tabindex', '0');

        // Move focus for screen reader if using keyboard
        /* if (lastFocusedElement && !$('body').hasClass('using-mouse')) {
            $alert.focus();
        } */

        // Determine timeout based on type
        if ($class === 'cc-alert--danger') {
            timeout = dangerTimeout;
            $alert.find('.js-alert-error-icon').removeClass('d-none');
            $alert.find('.js-alert-check-icon').addClass('d-none');
        } else {
            $alert.find('.js-alert-error-icon').addClass('d-none');
            $alert.find('.js-alert-check-icon').removeClass('d-none');
        }

        const hideAlert = () => {
            $alert
                .removeClass($class)
                .removeClass('cc-active')
                .attr('aria-hidden', 'true')
                .attr('tabindex', '-1');

            /* if (lastFocusedElement && typeof lastFocusedElement.focus === 'function' && document.body.contains(lastFocusedElement)) {
                lastFocusedElement.focus();
            } */
        };

        setTimeout(hideAlert, timeout);
    }
};

module.exports = {
    setHeaderHeight: setHeaderHeight,
    getWindowSizes: getWindowSizes,
    alertMessage: alertMessage
};
